var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{staticClass:"empty-img",attrs:{"src":require('@/static/news/empty.png'),"alt":""}}),_c('div',{staticClass:"empty-text"},[_vm._v("暂时还没有数据哦~·~")])])
}
var staticRenderFns = []

export { render, staticRenderFns }